import React, { createContext, useEffect, useState } from 'react';
import { Header } from 'components/Header/Header';
import { useDetailLocationParams } from 'hooks/useDetailLocationParams';
import { PageScroller } from 'components/PageScroller/PageScroller';
import { useApp } from 'providers/useApp/AppContext';
import { ContentContainer } from 'components/PageLayout/PageLayout.css';
import { Footer } from 'components/Footer/Footer';
import { MAIN_CONTENT_ID, useRouteFocus } from 'hooks/useRouteFocus/useRouteFocus';

export const LayoutContext = createContext<{
    setContentLoaded: (contentLoaded: boolean) => void;
}>(null);

export const PageLayout: React.FC<{ pathname: string; children?: React.ReactNode }> = ({ children, pathname }) => {
    const [contentLoaded, setContentLoaded] = useState<boolean>(true);
    const { isDetailPage } = useDetailLocationParams();
    const { isDesktop } = useApp();

    useRouteFocus(pathname);

    const allowedLocation = true;
    const enableFooter = !isDetailPage;

    useEffect(() => {
        if (!contentLoaded) {
            setContentLoaded(true);
        }
    }, [pathname]);

    return (
        <LayoutContext.Provider value={{ setContentLoaded }}>
            <PageScroller>
                {allowedLocation && <Header />}
                <ContentContainer id={MAIN_CONTENT_ID} tabIndex={-1} withFooter={enableFooter && isDesktop()}>
                    {children}
                </ContentContainer>
                {enableFooter && contentLoaded && <Footer />}
            </PageScroller>
        </LayoutContext.Provider>
    );
};
